import React from 'react';
import { CommonPageProps } from 'src/components/common/CommonPageProps';
import { Redirect } from 'react-router';
import { createCurrentWorkspaceDetailLink } from 'src/routes';

export const CurrentWorkspace = (props: CommonPageProps) => {
  return <Redirect push to={createCurrentWorkspaceDetailLink(props.activeWorkspace?.workspaceId)} />;
};
